const TOKEN_KEY = 'token';
export function setToken(token) {
	localStorage.setItem(TOKEN_KEY, token);
	console.log('>>> setToken:' + token);
}

export function getToken() {
	console.log('>>> getToken:' + localStorage.getItem(TOKEN_KEY));
	return localStorage.getItem(TOKEN_KEY);
}

export function cleanCache() {
	console.log('>>> clear Token:');
	localStorage.clear();
}
